/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, error: NonNullable<unknown> }} Integration_File_FailureInputs */

const en_integration_file_failure = /** @type {(inputs: Integration_File_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.error}`)
};

const es_integration_file_failure = /** @type {(inputs: Integration_File_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "{name}: {error}" |
*
* @param {Integration_File_FailureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_file_failure = /** @type {((inputs: Integration_File_FailureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_File_FailureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_file_failure(inputs)
	return en_integration_file_failure(inputs)
});